import React from 'react';
import {Button, Container, Grid, Icon, MenuItem, TextField} from "@mui/material";
import Typography from "@mui/material/Typography";
import clsx from "clsx";
import {makeStyles, withStyles} from "@mui/styles";
import {Form} from "formik";

const useStyles = makeStyles((theme) => ({
    button: {
        lineHeight: 2.5,
        fontSize: '1.4rem',
        backgroundColor: '#00b7f0',
        borderColor: '#00b7f0',
    },
    root: {
        '& .MuiPaper-elevation1': {
            boxShadow: 'none'
        }
    }
}));

const NautilusTextInput = withStyles({
    root: {
        backgroundColor: 'white',
        '& .MuiInputBase-input': {
            fontSize: '1.2rem',
            height: '2em',
        },
        '& .MuiFormLabel-root': {
            fontSize: '1.2rem',
        },
        '& label.Mui-focused': {
            color: '#1ebce7',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#1ebce7',
        },
        '& .MuiOutlinedInput-root': {
            borderRadius: 2,
            // '& fieldset': {
            //     borderColor: 'red',
            // },
            '&:hover fieldset': {
                borderColor: '#1ebce7',
            },
            '&.Mui-focused': {
                '& fieldset': {
                    borderColor: '#1ebce7',
                    '& legend': {
                        padding: '3px'
                    }
                }
            },
            '&.Mui-focused .MuiSelect-select fieldset': {
                '& legend': {
                    padding: '0'
                }
            },
        },
    },
})(TextField);

const RoomUpgradeForm = ({values, handleChange}) => {
    const classes = useStyles();

    return (
        <Container maxWidth={'lg'} id="WaitListForm"
                   style={{minWidth: 350, paddingLeft: 0, paddingRight: 0, marginTop: 50}}
                   className={classes.root}>
            <Form>
                <Grid container direction="row" justify="center" alignItems="center" style={{paddingBottom: 30}}>
                    <Grid item xs={12}>
                        <Typography variant="h3" component="h3">
                            Room Upgrade Information Request <br/>
                        </Typography>
                        <Typography variant="body1" component="p" style={{padding: 10, fontSize: '16px'}}>
                            Please provide some details so we can get in touch with you. Someone from our office will
                            contact you to discuss a room upgrade on this trip.
                        </Typography>
                    </Grid>
                    <Grid item xs={12} style={{padding: 5}}>
                        <NautilusTextInput fullWidth name="comments" value={values['comments']}
                                           placeholder={'Please indicate what upgrade are you interested in?'} onChange={handleChange} multiline
                                           rows={4} label="Please indicate What upgrade are you interested in?" variant="outlined"/>
                    </Grid>
                    <Grid item xs={12} style={{padding: 5}}>
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            fullWidth
                            className={clsx({[classes.button]: true, 'payButton': true})}
                            startIcon={<Icon>send</Icon>}
                        >
                            SUBMIT
                        </Button>
                    </Grid>

                </Grid>
            </Form>
        </Container>
    );
};

export default RoomUpgradeForm;